define('dialog/resize',['underscore', "dialog/position"], function(_, POS){
  // pw is power : when < 1 it eases out, when > 1 it eases in, when 1 it is linear
  function inOut(min,max,steps,curStep,pw) {
    var d = max - min;
    var step = min+(Math.pow(((1 / steps) * curStep), pw) * d);
    return Math.ceil(step);
  }

  var Resize = _.extend({}, POS);

  Resize.animate = function (startW, endW, startH, endH, steps, intervals, pw, overflow) {
    // We should not resize if there are no steps nor intervals (in ms)
    if (!steps || ! intervals || ! pw){
      return;
    }
    var sW = startW, eW = endW, sH  = startH, eH = endH, pwW = pw, pwH = pw;
    // Clear the animation interval for this dialog
    if (this.ai){
      window.clearInterval(this.ai)
    }
    var curStep = 0;
    this.ai = window.setInterval(_.bind(function() {
      if (startW > endW){
        pwW = 1 / pw;
      }
      if (startH > endH){
        pwH = 1 / pw;
      }
      var w = inOut(sW, eW, steps, curStep, pwW);
      var h = inOut(sH,eH,steps,curStep,pwH);
      this.setWidth(w);
      this.setHeight(h);
      curStep++;
      if (curStep > steps){
        window.clearInterval(this.ai);
        this.inform('dialog.resize', endW, endH, overflow);
      }
      this.pos();
    }, this), intervals);
  };

  Resize.resize = function(w,h,overflow){
    this.animate(this.width(),w, this.height(), h, 30, 1, 2, overflow);
    return this;
  };

  return Resize;
})
;
